import VueTypes, { nullable } from 'vue-types';

// MODEL: SliderItem
export const SliderItem = VueTypes.shape({
    title: VueTypes.oneOfType([String, nullable]).def(null),
    description: VueTypes.oneOfType([String, nullable]).def(null),
    btnText: VueTypes.string.isRequired,

    imageDesktop: VueTypes.string.isRequired,
    imageTablet: VueTypes.string,
    imageMobile: VueTypes.string,

    url: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

export const createSliderItem = ({ title, description, btnText, imageDesktop, imageMobile, imageTablet, url, autoplay = 10 }) => {
    return {
        title: title,
        description: description,
        btnText: btnText,
        imageDesktop: imageDesktop,
        imageTablet: imageTablet,
        imageMobile: imageMobile,
        url: url,
        autoplay: autoplay
    };
};
